import { apiSlice } from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: { ...credentials },
      }),
    }),
    adLogin: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login/azure-ad",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: { ...credentials },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useAdLoginMutation,
  useChangePasswordMutation,
} = authApiSlice;
